import { RootState } from "../../../store";
import { dimensionsSliceSelector } from "../dimensionsSliceSelector";

export const dimensionNameSelector = (state: RootState) => {
  const slice = dimensionsSliceSelector(state);

  return slice.dimensionName;
};
